// extracted by mini-css-extract-plugin
module.exports = {"root":"input_root__2YLAA","label":"input_label__3U8g9","label__span":"input_label__span__1n8RF","input":"input_input__3lMsS","message":"input_message__3ygqb"};